import { Resolver } from 'react-hook-form';
import { descriptionField } from 'src/services/orderLink/orderLink.config';
import createLength from 'src/utils/validation/length';
import required from 'src/utils/validation/required';
import {
  validateFieldSync,
  validateFormSync,
} from 'src/utils/validation/validate-generators';

export const formConfigOrderImportPayByLink = (Descrizione: string) => {
  const initialValues = {
    [descriptionField]: Descrizione,
  };

  const validate = validateFormSync({
    [descriptionField]: validateFieldSync(
      required,
      createLength({ min: 0, max: 200 }),
    ),
  });

  const resolver: Resolver<any> = async (values: any) => {
    return {
      values: values,
      errors: validate(values),
    };
  };
  return { initialValues, resolver };
};
